import React from 'react';

import DetailsView from './detailsView';

/**
 * CellDetailsView — a cell's title and description, read-only.
 *
 * The READ-ONLY half of the Details section, extracted for the same reason CellWorkflowView was:
 * the mission map's dock and the cell detail surface both say what this cell is, and the answer
 * must not depend on which one you asked. Editing lives only in `cellPanel.js`, and only while the
 * cell is a draft AND the revision and session allow it.
 *
 * What is left here after DetailsView took the rendering is the one thing that is about CELLS: the
 * title fallback. The mission panel renders the same pair through the same view.
 *
 * Props:
 *   cell      — cell vertex object ({ element_id, props })
 *   collapsed — show the title alone; the description is what folding this section puts away
 *   fileContext — passed to the description's file blocks
 */
export default function CellDetailsView({ cell, collapsed, fileContext }) {
  const props = (cell && cell.props) || {};
  // A cell always states itself with a title: the orchestrator's own templates rely on it being
  // present and fall back to the id, so this view falls back to exactly the same thing.
  const title = props.title || (cell && cell.element_id) || '';
  // Collapsed reads as an absent description, which DetailsView already renders as nothing at all —
  // one code path for "there is none" and "not right now", so a folded section and a cell nobody
  // described look the same, because they should.
  return <DetailsView title={title} description={collapsed ? null : props.description} fileContext={fileContext} />;
}
